import { useUserConfig } from '../userConfig/useUserConfig';
import { useI18nContext } from './useI18nContext';

export function useI18n() {
  const { locale, setLocale } = useUserConfig();
  const { translate } = useI18nContext();
  return { locale, setLocale, translate };
}
